const SET_RESET_PASSWORD_CONSENT = 'classpass/resetPassword/SET_RESET_PASSWORD_CONSENT';

const initialState = {
  consent: null,
};

export function reducer(state = initialState, action = {}) {
  const { type, ...payload } = action;

  switch (type) {
    case SET_RESET_PASSWORD_CONSENT:
      return { ...state, ...payload };
    default:
      return state;
  }
}

export const setResetPasswordConsent = consent => ({ type: SET_RESET_PASSWORD_CONSENT, consent });
export const selectResetPasswordConsent = state => state.features.resetPassword.consent;
